export default {"src":"/_next/static/media/ci.d4bd42dc.svg","height":72,"width":72};